/*
  D78 . Prevenez-moi . Klaviyo Back in Stock natif.

  Cle PUBLIQUE uniquement (company_id). Aucune cle privee cote client.
  Pas de balise form : la fiche produit est deja dans un form Shopify,
  imbriquer un second form casse la soumission du panier.

  La variante est relue dans le DOM au moment du clic, donc l abonnement
  porte sur le format reellement selectionne par le client.

  Prerequis fonctionnel : Klaviyo ne connait une variante comme epuisee que
  si Shopify en suit le stock. Une variante dont le suivi d inventaire est
  coupe n est jamais vue en rupture, et l abonnement ne se declenchera jamais.
*/
(function () {
  'use strict';

  var REVISION = '2025-01-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function shopifyVariantId(el) {
    var form = el.closest('product-form');
    if (form) {
      var input = form.querySelector('input[name="id"]');
      if (input && input.value) return input.value;
    }
    return el.dataset.variantId || '';
  }

  function messages(el) {
    var t = el.querySelector('[data-moojo-notify-messages]');
    return {
      success: (t && t.dataset.success) || '',
      invalid: (t && t.dataset.invalid) || '',
      error: (t && t.dataset.error) || ''
    };
  }

  function say(el, text, kind) {
    var box = el.querySelector('[data-moojo-notify-feedback]');
    if (!box) return;
    box.textContent = text;
    box.hidden = false;
    box.setAttribute('data-kind', kind);
  }

  function subscribeBackInStock(companyId, email, variantId) {
    return fetch(
      'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: {
              variant: {
                data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
              }
            }
          }
        })
      }
    );
  }

  function subscribeNewsletter(companyId, email, listId) {
    return fetch(
      'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
      {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      }
    );
  }

  class MoojoNotify extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;
      this.dataset.bound = 'true';

      const el = this;
      const button = el.querySelector('[data-moojo-notify-submit]');
      const field = el.querySelector('[data-moojo-notify-email]');
      if (!button || !field) return;

      const submit = () => {
        const msg = messages(el);
        const email = (field.value || '').trim();

        if (!EMAIL_RE.test(email)) {
          say(el, msg.invalid, 'invalid');
          field.focus();
          return;
        }

        const companyId = el.dataset.companyId;
        const variantId = shopifyVariantId(el);
        if (!companyId || !variantId) {
          say(el, msg.error, 'error');
          return;
        }

        button.disabled = true;

        subscribeBackInStock(companyId, email, variantId)
          .then((res) => {
            if (!res.ok && res.status !== 202) throw new Error('klaviyo ' + res.status);

            const consent = el.querySelector('[data-moojo-notify-consent]');
            const listId = el.dataset.newsletterList;
            if (consent && consent.checked && listId) {
              // l alerte est enregistree : une lettre refusee ne doit pas la faire echouer
              return subscribeNewsletter(companyId, email, listId).catch(() => {});
            }
            return null;
          })
          .then(() => {
            say(el, msg.success, 'success');
            field.disabled = true;
            button.hidden = true;
          })
          .catch(() => {
            say(el, msg.error, 'error');
            button.disabled = false;
          });
      };

      button.addEventListener('click', submit);
      field.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          submit();
        }
      });
    }
  }

  if (!customElements.get('moojo-notify')) {
    customElements.define('moojo-notify', MoojoNotify);
  }

  /* Mini-carte quand la fiche est indisponible. Le clic ramene au champ
     deja present dans le bloc d achat. Esperanza faisait cela seule. */
  var stickyLine = document.querySelector('[data-esperanza-sticky-harvest]');
  var availabilityLine = document.querySelector('.moojo-availability__line');
  if (stickyLine && availabilityLine && !stickyLine.textContent.trim()) {
    stickyLine.innerHTML = availabilityLine.innerHTML;
  }

  var notify = document.querySelector('moojo-notify');
  if (notify && !document.getElementById('acheter')) notify.id = 'acheter';

  var stickyNotify = document.querySelector('[data-esperanza-sticky-notify]');
  if (stickyNotify && stickyNotify.dataset.moojoStickyBound !== 'true') {
    stickyNotify.dataset.moojoStickyBound = 'true';
    stickyNotify.addEventListener('click', function () {
      var field = document.querySelector('[data-moojo-notify-email]');
      var target = document.getElementById('acheter') || field;
      if (!target) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 106;
      var top = target.getBoundingClientRect().top + window.scrollY - header - 12;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#acheter');
      if (field) window.setTimeout(function () { field.focus({ preventScroll: true }); }, reduce ? 0 : 350);
    });
  }
})();
